import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TYPE_FILTER_OPTIONS } from '@/lib/projectFilters';

/**
 * The Capital / MOE / Tenant dropdown.
 *
 * One component rather than one per page, for the same reason the options are
 * derived from TYPE_LABELS rather than typed out: the Projects page and the
 * Dashboard both offer this filter, and two copies of it are two places for
 * the wording to drift apart.
 *
 * The width is a prop because the Projects page sits it in a row of filters
 * sized to match, while the Dashboard tucks it beside a section heading.
 */
export default function ProjectTypeFilter({ value, onChange, className = 'w-40' }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className} aria-label="Filter by project type">
        <SelectValue placeholder="All Types" />
      </SelectTrigger>
      <SelectContent>
        {TYPE_FILTER_OPTIONS.map(opt => (
          <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
